import { Link } from "react-router-dom";

function dayDiff(a, b) {
  return Math.round((new Date(a + "T00:00:00") - new Date(b + "T00:00:00")) / 86400000);
}

export default function UpNext({ trips, today }) {
  const upcoming = (trips || [])
    .filter((t) => t.start_date && t.start_date > today)
    .sort((a, b) => a.start_date.localeCompare(b.start_date));
  if (upcoming.length === 0) return null;
  const shown = upcoming.slice(0, 3);

  return (
    <div className="bg-surface border border-hairline rounded-card px-5 pt-4 pb-1" data-testid="home-up-next">
      <p className="label-tag mb-1">Up next</p>
      {shown.map((t, i) => {
        const d = new Date(t.start_date + "T00:00:00");
        const away = dayDiff(t.start_date, today);
        const len = t.end_date ? dayDiff(t.end_date, t.start_date) + 1 : 1;
        return (
          <Link
            key={t.id}
            to={`/trips/${t.id}`}
            className={`flex items-center gap-3.5 py-3 ${i < shown.length - 1 || upcoming.length > 3 ? "border-b border-hairline" : ""}`}
            data-testid={`up-next-row-${t.id}`}
          >
            <div className="w-11 text-center shrink-0">
              <p className="font-mono text-[11px] text-ember uppercase">
                {d.toLocaleDateString(undefined, { month: "short" })}
              </p>
              <p className="font-mono text-xl leading-none mt-0.5">{String(d.getDate()).padStart(2, "0")}</p>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-display text-lg leading-snug truncate">{t.destination || t.name}</p>
              <p className="font-mono text-[10px] text-sand-400 tracking-wide mt-0.5">
                {len} DAY{len !== 1 ? "S" : ""} · {away} DAY{away !== 1 ? "S" : ""} AWAY
              </p>
            </div>
            <span className="text-sand-300 shrink-0">→</span>
          </Link>
        );
      })}
      {upcoming.length > 3 && (
        <Link
          to="/trips"
          className="block py-3 text-center font-mono text-[10px] font-semibold uppercase tracking-wider text-ember"
          data-testid="up-next-all"
        >
          All trips →
        </Link>
      )}
    </div>
  );
}
